import React from 'react';
import PropTypes from 'prop-types';
import ODropDownMenu from '../../../UI/DropDownMenu/ODropDownMenu';

const GridOptions = ({
  children,
  handleOpenDialog,
  getEditData,
  handleOpenDialogFile,
}) => {
  const options = [
    {
      title: 'Izmeni',
      subtitle: 'Izmenite podatke za izabranu mašinu',
      path: 'profil',
      id: 1,
      icon: 'fas fa-pen',
      color: '#2f3a3f',
      onClick: () => getEditData(),
    },
    {
      title: 'Obriši',
      subtitle: 'Obrišite izabranu mašinu',
      path: 'login',
      id: 2,
      icon: 'fas fa-trash',
      color: '#ff5552',
      onClick: () => handleOpenDialog(),
    },
    {
      title: 'Fajl',
      subtitle: 'Dodaj fajl',
      path: 'login',
      id: 3,
      icon: 'fas fa-file',
      color: '#2f3a3f',
      onClick: () => handleOpenDialogFile(),
    },
  ];

  return (
    <ODropDownMenu align="end" position="anchor" options={options}>
      {children}
    </ODropDownMenu>
  );
};

GridOptions.propTypes = {
  children: PropTypes.node.isRequired,
  handleOpenDialog: PropTypes.func.isRequired,
  getEditData: PropTypes.func.isRequired,
};

export default GridOptions;
